import type { PaletteOptions } from '@mui/material/styles';

export const palette: PaletteOptions = {
  mode: 'light',
  primary: {
    main: '#ee2e24',
    light: '#f25c54',
    dark: '#c4241c',
    contrastText: '#ffffff',
  },
  secondary: {
    main: '#455a64',
    light: '#718792',
    dark: '#1c313a',
    contrastText: '#ffffff',
  },
  background: {
    default: '#f5f7fa',
    paper: '#ffffff',
  },
  text: {
    primary: '#1a1a2e',
    secondary: '#5c6b7a',
  },
};
